import { resolveProfileImageUrl } from '@hooks/projects/detail/useProjectDetail';

/** Avatar path from auth user (API may use avatarUrl, avatar, or profileImage). */
export function getUserAvatarPath(user) {
    if (!user) return null;
    return user.avatarUrl ?? user.avatar ?? user.profileImage ?? null;
}

/** Resolved absolute URL for displaying the current user's avatar. */
export function getUserAvatarUrl(user, apiUrl) {
    const path = getUserAvatarPath(user);
    return path ? resolveProfileImageUrl(path, apiUrl) : null;
}

export function getUserInitialsFromUser(user) {
    if (user?.name) {
        return user.name
            .split(' ')
            .map((n) => n[0])
            .join('')
            .toUpperCase()
            .slice(0, 2);
    }
    return user?.email?.[0]?.toUpperCase() || 'U';
}
